import { useCallback, useEffect } from 'react';

import { isMacOS } from '../utils';

//  Helper for determining if the CMD or CTRL key is pressed.
const isModifierKeyPressed = (event: KeyboardEvent) => isMacOS()
  ? event.metaKey
  : event.ctrlKey;

const normalizeKey = (key: KeyboardEvent['key']) => key?.toLowerCase();

/**
 * Calls the callback when CMD+K is pressed. (CTRL+K on Windows)
 */
function useCmdKPress(callback: () => void) {
  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    const key = normalizeKey(event.key);
    if (isModifierKeyPressed(event) && key === 'k') {
      event.preventDefault();
      callback();
    }
  }, [callback]);
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
}

export default useCmdKPress;
